import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashTransferSearchResponse from "../CashTransferSearchResponse";
import ModelProxyClass from "./ModelProxyClass";
import CashTransfer from "../CashTransfer";


/**
 * @class CashTransferSearchResponseBase
 * @extends ModelBaseClass
 * @property {[CashTransfer]} cashTransfers
 * @property {number} totalItemCount (int64)
 */
class CashTransferSearchResponseBase extends ModelBaseClass {
	/**
	 * @type {[CashTransfer]} cashTransfers
	 */
	cashTransfers;
	/**
	 * @type {number} totalItemCount (int64)
	 */
	totalItemCount;

	/**
	 * Instantiates a new instance of CashTransferSearchResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashTransferSearchResponse}
	 */
	static create(genericObject) {
		const newCashTransferSearchResponse = new CashTransferSearchResponse();
		newCashTransferSearchResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashTransferSearchResponse;
	}

	/**
	 * Instantiates a new array of CashTransferSearchResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashTransferSearchResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashTransferSearchResponseArray = [];
		genericArray.forEach(genericObject => {
			newCashTransferSearchResponseArray.push(CashTransferSearchResponse.create(genericObject));
		});
		return newCashTransferSearchResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashTransfers', '[CashTransfer]'),
	ModelBaseClass.createModelProperty('totalItemCount', 'integer'),
];

export default CashTransferSearchResponseBase;
